const metaDataModel = (data) => ({
  moduleName: data.moduleName,
  lastSynced: data.lastSynced || null,
  isPagination: data.isPagination || false,
  paginationStartIndex: data.paginationStartIndex || null,
  paginationEndIndex: data.paginationEndIndex || null,
});

export default metaDataModel;
